let basePath;
let appId;

const testBasePath = "/check";
const prodBasePath = "/check";

const testHost = "https://testinstruct.ntc.edu" + testBasePath;
const prodHost = "https://instruct.ntc.edu" + prodBasePath;

const appUrl = window && window.location && window.location.href;

if (appUrl.toLowerCase().startsWith(prodHost)) {
  // Running in prod.
  basePath = prodBasePath;
  appId = "check";
} else if (appUrl.toLowerCase().startsWith(testHost)) {
  // Running in test.
  basePath = testBasePath;
  appId = "testcheck";
} else {
  // Running in dev.
  basePath = "";
  appId = "devcheck";
}

export const APP_BASE_PATH = basePath;

export const APP_ID = appId;
